import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import { AbsenceIcon, PermissionIcon, LicenceIcon } from "@icarius-icons/";
import paths from "@icarius-router/paths";
import { AssetsAndDiscountsSummaryIcon, HolidayTableIcon } from "@icarius-icons/index";
import { getLocalizedString } from "@icarius-localization/strings";

const IssueTypeSettings = () => {

  const data = [
    {
      name: getLocalizedString("issueAbsences"),
      icon: <AbsenceIcon />,
      path: paths.issueAbsences,
    },
    {
      name: getLocalizedString("issuePermissions"),
      icon: <PermissionIcon />,
      path: paths.issuePermissions,
    },
    {
      name: getLocalizedString("issueLicences"),
      icon: <LicenceIcon />,
      path: paths.issueLicences,
    },
    {
      name: getLocalizedString("issueVacations"),
      icon: <HolidayTableIcon />,
      path: paths.issueVacations,
    },
    {
      name: getLocalizedString("issueSummary"),
      icon: <AssetsAndDiscountsSummaryIcon />,
      path: paths.issueSummary,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("issueManagementScreenSelector")}
      data={data}
    />
  );
}

export default IssueTypeSettings;
